import React from 'react'

const index = () => {
  return (
    <div>Liablity</div>
  )
}

export default index